import { Component, OnInit } from '@angular/core';
import { CommonService } from 'src/app/services/common.service';

@Component({
  selector: 'app-loader',
  templateUrl: './loader.component.html',
  styleUrls: ['./loader.component.css']
})
export class LoaderComponent implements OnInit {

  isLoading: boolean = false;
  constructor(private commonService: CommonService) {
    this.commonService.isLoading.subscribe((val) => {
      this.isLoading = val;
    });
  }

  ngOnInit(): void {
  }

}
